var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2362",
    d: "M15 9.5L17.1494 10.1448C18.5226 10.5568 19.2092 10.7628 19.6046 11.2942C20 11.8256 20 12.5425 20 13.9761V21.5",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 8.5L10 8.5M7 12.5L10 12.5",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2360",
    d: "M11 21.5V18.5C11 17.5572 11 17.0858 10.7071 16.7929C10.4142 16.5 9.94281 16.5 9 16.5H8C7.05719 16.5 6.58579 16.5 6.29289 16.7929C6 17.0858 6 17.5572 6 18.5V21.5",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6003",
    d: "M1 21.5L21 21.5",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 6728",
    d: "M2 21.5V6.21724C2 3.70649 2 2.45111 2.79118 1.82824C3.58237 1.20537 4.74742 1.54355 7.07752 2.2199L12.0775 3.67122C13.4836 4.07937 14.1867 4.28344 14.5933 4.83965C15 5.39587 15 6.15344 15 7.66857V21.5",
    stroke: "#5784F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIcon7);
export default __webpack_public_path__ + "static/media/LineIcon7.28561c264475e7153f25cc18bfc6744a.svg";
export { ForwardRef as ReactComponent };